interface DatePickerProps {
  selected: string; // ISO date string "YYYY-MM-DD"
  onSelect: (date: string) => void;
  days?: number;
}

function formatDate(date: Date): string {
  // Use LOCAL date, not UTC, to avoid timezone-off-by-one bugs.
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

function getDates(days: number): Date[] {
  const dates: Date[] = [];
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  for (let i = 0; i < days; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    dates.push(d);
  }
  return dates;
}

function getDayLabel(date: Date): string {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (date.getTime() === today.getTime()) return "Today";
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  if (date.getTime() === tomorrow.getTime()) return "Tmrw";
  return date.toLocaleDateString(undefined, { weekday: "short" });
}

export function DatePicker({ selected, onSelect, days = 30 }: DatePickerProps) {
  const dates = getDates(days);

  return (
    <div className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1">
      {dates.map((date) => {
        const iso = formatDate(date);
        const isSelected = iso === selected;
        return (
          <button
            key={iso}
            type="button"
            onClick={() => onSelect(iso)}
            className={`shrink-0 flex flex-col items-center justify-center w-14 h-16 rounded-[var(--radius)] border-2 text-xs font-medium transition-all ${
              isSelected
                ? "border-[var(--accent)] text-white"
                : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
            }`}
            style={isSelected ? { backgroundColor: "var(--accent)", borderColor: "var(--accent)" } : {}}
          >
            <span className="text-[10px] uppercase tracking-wide">{getDayLabel(date)}</span>
            <span className="text-lg font-bold leading-tight">{date.getDate()}</span>
            <span className="text-[10px] uppercase">
              {date.toLocaleDateString(undefined, { month: "short" })}
            </span>
          </button>
        );
      })}
    </div>
  );
}
